import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

declare var $: any;  // Declaring $ as a variable so that we can use it to access jQuery

@Component({
    selector: 'count-days',
    templateUrl: './days.component.html'
})
export class DaysComponent implements OnInit {
    message : string;
    days : number;
    
    @ViewChild('sd') sdate : ElementRef;
    @ViewChild('ed') edate : ElementRef;
    
    constructor() {  }

    ngOnInit(): void {
        $(
            function() {
                
                var maxBirthdayDate = new Date();
                 maxBirthdayDate.setFullYear( maxBirthdayDate.getFullYear() - 18 );
                 maxBirthdayDate.setMonth(11,31)
                 
                 $(".dob_customers12").datepicker( {dateFormat : "dd-mm-yy",
                                                 autoclose:true,
                                                 changeYear:true,
                                                 changeMonth: true,
                                                 maxDate: maxBirthdayDate,
                                                 onSelect: function(dateText) {
                                                    var input = $('.dob_customers12');
                                                    input.val(this.value).removeClass('is-invalid');
                                                    input.removeClass('ng-invalid')
                                                    input.addClass('ng-valid')
                                                     input.trigger('input'); // Use for Chrome/Firefox./Edge
                                                    input.trigger('change');
                                                    input.trigger('focusin');
                                                   
                                                     // Use for Chrome/Firefox/Edge + IE11
                                                },
                                                 yearRange: '1950:'+maxBirthdayDate.getFullYear() });
                                                
               
            }
        );         
     }
   
    getNoDays() {
         this.message = "";
         this.days = 0;
         
         let startDate = this.sdate.nativeElement.value;
         let endDate = this.edate.nativeElement.value;
          
         if (startDate && endDate) {
            var start  = new Date(startDate)
            var end = new Date(endDate)
            let ms = (end.getTime() - start.getTime()); // get no. of milliseconds between dates
            // find out no. of days
            this.days = ms / (1000 * 60 * 60 * 24); // divide total milliseconds by no. of milliseconds per day
        }
        else{
            this.message = "Please select dates first!"
        }
    }
}